import { RouterProvider } from "react-router-dom";
import "./App.css";
import { router } from "./routes";
import { DeviceContext } from "./Contexts/DeviceContext";
import { useState } from "react";

function App() {
  const [devices, setDevices] = useState([]);

  return (
    <div className="App">
      <DeviceContext.Provider value={{ devices, setDevices }}>
        <RouterProvider router={router} />
      </DeviceContext.Provider>
    </div>
  );
}

export default App;
